import React from 'react';
import styles from './RecipeTypeIndicator.module.css';

interface RecipeTypeIndicatorProps {
  type: 'saved' | 'created' | 'variant';
  className?: string;
}

const RecipeTypeIndicator: React.FC<RecipeTypeIndicatorProps> = ({ type, className }) => {
  const getTypeText = () => {
    switch (type) {
      case 'saved':
        return 'Saved';
      case 'created':
        return 'Created';
      case 'variant':
        return 'Customized';
      default:
        return '';
    }
  };

  return (
    <span className={`${styles.typeIndicator} ${styles[`type-${type}`]} ${className || ''}`}>
      {getTypeText()}
    </span>
  );
};

export default RecipeTypeIndicator;